// src/Utils/TableLoaderOverlay.js
import React from "react";

const TableLoaderOverlay = ({ isLoading }) => {
  return (
    <div
      style={{
        ...overlayStyles,
        opacity: isLoading ? 1 : 0, // fade in/out
        pointerEvents: isLoading ? "auto" : "none", // block clicks only when visible
      }}
    />
  );
};

const overlayStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(255, 255, 255, 0.6)", // light opacity
  zIndex: 10,
  transition: "opacity 0.35s ease-in-out", // smooth fade
};

export default TableLoaderOverlay;
